import { useCallback } from 'react';

import { useEffectOnce } from 'src/lib/hooks';
import { usePopups } from 'src/lib/popups';

import { AccountExtractionLoaderPopup } from './AccountExtractionLoaderPopup';

export const EXTRACTION_LOADER_POPUP = Symbol('EXTRACTION_LOADER');

export const useAccountExtractionLoaderPopup = () => {
  const popups = usePopups();

  useEffectOnce(() => {
    popups.registerPopup(EXTRACTION_LOADER_POPUP, AccountExtractionLoaderPopup);
  });

  return useCallback(
    ({ account, customModelAccount, isTrainingModel, isAlreadyConnected }) => {
      popups.openPopup(EXTRACTION_LOADER_POPUP, {
        account,
        customModelAccount,
        isTrainingModel,
        isAlreadyConnected,
        onClose: () => {
          popups.closePopup(EXTRACTION_LOADER_POPUP);
        },
      });
    },
    [popups]
  );
};
